import moment from "moment";
import Button from "@material-ui/core/Button";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { GetAllCsvData } from "../../redux/reducers/EventReducer";
import FullPageLoader from "./FullPageLoader";
import { useState } from "react";
import { stringify } from "csv-stringify";
import { useDispatch } from "react-redux";
import { generateToast } from "../../helper";
import { ERROR } from "../../constant";
const CsvExport = ({ EventData, mode }) => {
  const Headers = [
    "Created At",
    "Start Date",
    "Client Name",
    "Client Type",
    "Collaborator Name",
    "Sold By",
    "Created By",
    "Client Budget",
    "Total Cost",
    "Remaining Budget",
    "Contract Status",
    "Sign Date",
    "Is Invoiced",
  ];
  const dispatch = useDispatch();
  const currentDateShortened = moment().format("MM-DD-YYYY");
  const [csvLoading, setCsvLoading] = useState(false);
  const ExportFilteredData = () => {
    setCsvLoading(true);
    const formattedData = EventData?.data?.map((event) => [
      event.createdAt,
      event.startDate,
      event.eventClients[0]?.client?.name ?? "",
      event.clientType?.name ?? "",
      event.eventClients[0]?.collaborator?.name,
      event.soldBy?.firstName || +event.soldBy?.lastName || "",
      event.createdBy?.firstName || +event.createdBy?.lastName || "",
      event.clientBudget,
      event.totalCost,
      event.clientBudget - event.totalCost,
      event.contractStatus,
      event.signDate || "",
      event.isInvoiced,
    ]);
    stringify([Headers, ...formattedData], (err, output) => {
      if (err) {
        generateToast(err.message, ERROR);
        setCsvLoading(false);
        return;
      }
      const blob = new Blob([output], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `TPE-CONTRACTS-${currentDateShortened}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setCsvLoading(false);
    });
  };

  const handleExport = async () => {
    setCsvLoading(true);
    const csvDataPayload = await dispatch(GetAllCsvData());
    const AllCsvData = csvDataPayload?.payload;
    const HeadersPayload = AllCsvData?.data[0];

    const Headers = [
      HeadersPayload?.[30],
      HeadersPayload?.[2],
      HeadersPayload?.[40],
      HeadersPayload?.[34],
      HeadersPayload?.[40],
      HeadersPayload?.[38],
      HeadersPayload?.[39],
      HeadersPayload?.[10],
      HeadersPayload?.[11],
      HeadersPayload?.[10],
      HeadersPayload?.[22],
      HeadersPayload?.[23],
      HeadersPayload?.[25],
    ];
    const csvData = AllCsvData?.data?.slice(1);
    const formattedData = csvData?.map((event) => [
      event?.[30],
      event?.[2],
      event?.[40][0]?.client?.name ?? "",
      event?.[34]?.name ?? "",
      event?.[40][0]?.collaborator?.name,
      event?.[38]?.firstName || +event?.[38]?.lastName || "",
      event?.[39]?.firstName || +event?.[39]?.lastName || "",
      event?.[10],
      event?.[11],
      event?.[10] - event?.[11],
      event?.[22],
      event?.[23] || "",
      event?.[25],
    ]);
    stringify([Headers, ...formattedData], (err, output) => {
      if (err) {
        console.error(err);
        return;
      }
      const blob = new Blob([output], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `TPE-CONTRACTS-${currentDateShortened}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setCsvLoading(false);
    });
  };

  return (
    <div>
      <Button
        variant="outlined"
        style={{
          height: "2.1rem",
          fontSize: "12px ",
          marginLeft: "5px",
          marginRight: "5px",
          marginTop: "5px",
          border: mode === "dark" ? "1px solid lightgray" : "1px solid green",
          borderRadius: "6px",
        }}
        onClick={handleExport}
      >
        <FileDownloadIcon
          style={{
            color: "green",
          }}
        />{" "}
        <span
          style={{
            color: mode === "dark" ? "white" : "green ",
          }}
        >
          {" "}
          EXPORT ALL DATA(CSV)
        </span>
      </Button>
      {csvLoading ? <FullPageLoader /> : ""}
      <Button
        variant="outlined"
        style={{
          height: "2.1rem",
          fontSize: "12px ",
          marginLeft: "5px",
          marginRight: "5px",
          marginTop: "5px",
          border: mode === "dark" ? "1px solid lightgray" : "1px solid green",
          borderRadius: "6px",
        }}
        onClick={ExportFilteredData}
      >
        <FileDownloadIcon
          style={{
            color: "green",
          }}
        />{" "}
        <span
          style={{
            color: mode === "dark" ? "white" : "green ",
          }}
        >
          EXPORT FILTERED DATA(CSV)
        </span>
      </Button>
    </div>
  );
};

export default CsvExport;
